import { UserRoleType } from 'types/apis/auth';

export enum LoginFormField {
  UserRole = 'userRole',
  LoginId = 'loginId',
  Password = 'password',
}

export enum VerificationEmailFormField {
  UserRole = 'userRole',
  Name = 'name',
  LoginId = 'loginId',
  VerificationNum = 'verificationNum',
}

export enum PasswordChangeFormFields {
  NewPassword = 'newPassword',
  NewPasswordCheck = 'newPasswordCheck',
}

export enum TermsField {
  TermsAgree = 'termsAgree',
}

export enum TermsFormField {
  TermsCheckAll = 'termsCheckAll',
  PrivatePolicy = 'privatePolicy',
  TermsOfUse = 'termsOfUse',
}

export type TVerificationEmailForms = {
  [VerificationEmailFormField.UserRole]: UserRoleType;
  [VerificationEmailFormField.Name]: string;
  [VerificationEmailFormField.LoginId]: string;
  [VerificationEmailFormField.VerificationNum]?: string;
};

export type TPasswordChangeForm = {
  [PasswordChangeFormFields.NewPassword]: string;
  [PasswordChangeFormFields.NewPasswordCheck]: string;
};

export type TPasswordChangeParams = {
  loginId?: string;
  userRole?: UserRoleType;
  newPassword: string;
  newPasswordCheck: string;
};

export type TTermsForm = {
  [TermsField.TermsAgree]: string[];
};
